<template>
    <div id="root" class="root">
        <!-- ################ PopUp  ################ -->
        <div v-if="showPopup || showPopup2 || showPopup3" class="popup_overlay" @click.prevent.stop="closePopup()">
            <div v-if="showPopup" class="dv_popup_mail" onclick="event.stopPropagation();">
                <div style="display: flex; width: 100%; justify-content: flex-end;">
                    <div style="width: 3vh; height: 3vh; margin-bottom: -3vh; z-index: 20; cursor: pointer;" @click.prevent.stop="closePopup()">
                        <img src="/static/imgs/ic_fechar.svg" style="background-color: var(--dark-brown-font); width: 100%; height: 100%; padding: 0.5vh; margin-left: -0.5vh; margin-top: -0.5vh;"/>
                    </div>
                </div>
                <div style="border-width: 2px; border-style: solid; border-color: var(--light-yellow); height: calc(100% - 4vh); text-align: left; padding: 2vh; display: flex; flex-direction: column; justify-content: space-between;">
                    <div>
                        <span class="tx_popup1">FAÇA PARTE DO</span>
                        <div>
                            <span class="tx_popup1">NOSSO</span>
                            <span class="tx_popup2">MAILLING</span>
                        </div>
                    </div>

                    <span class="tx_popup3">E receba com exclusividade nossos programas e pacotes especiais.</span>

                    <input class="ipt_popup" :placeholder="tx_digite_email" v-model="new_email" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>
                </div>
            </div>

            <div v-if="showPopup2" class="dv_popup_mail2" onclick="event.stopPropagation();">
                <div style="display: flex; width: 100%; justify-content: flex-end;">
                    <div style="width: 3vh; height: 3vh; margin-bottom: -3vh; z-index: 20; cursor: pointer;" @click.prevent.stop="closePopup()">
                        <img src="/static/imgs/ic_fechar.svg" style="background-color: var(--light-gray-font); width: 100%; height: 100%; padding: 0.5vh; margin-left: -0.5vh; margin-top: -0.5vh;"/>
                    </div>
                </div>
                <div style="border-width: 2px; border-style: solid; border-color: var(--light-yellow); height: calc(100% - 4vh); text-align: left; padding: 2vh; display: flex; flex-direction: column; justify-content: space-between;">
                    <div>
                        <span class="tx_popup1">QUER RECEBER</span>
                        <div>
                            <span class="tx_popup1">MAIS</span>
                            <span class="tx_popup2_2">INFORMAÇÕES?</span>
                        </div>
                    </div>

                    <span class="tx_popup3">Através do nosso mailling, você receberá pacotes especiais e tarifas promocionais.</span>

                    <input class="ipt_popup" :placeholder="tx_digite_email" v-model="new_email" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>
                </div>
            </div>

            <div v-if="showPopup3" class="dv_popup_checkin" onclick="event.stopPropagation();">
                <div style="display: flex; width: 15%; height: 20%; cursor: pointer" @click.prevent.stop="closePopup()">
                </div>
                <a style="display: flex; width: 50%; height: 35%;" href="https://easycheckin.vegait.com.br/ls-hotel/ls-hotel" target="_blank">
                </a>
            </div>
        </div>

        <div class="overlay" @click="changeSideBar()"></div>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: 'Home',
    data () {
        return {
            name: 'Home',
            tx_historia: 'Inaugurado em 2018 como o primeiro hotel design de João Pessoa, o LS Hotel reúne luxo, conforto e exclusividade em um projeto de alto padrão, onde a combinação entre design e hotelaria lança um conceito único em hospedagem na capital paraibana. Conheça o requinte de nossa estrutura e os atrativos de nossos serviços, a experiência de se hospedar no LS Hotel com certeza irá lhe surpreender.',
            tx_localizacao: 'Localizado em Manaíra, um dos mais nobres bairros de João Pessoa, o LS está a poucos passos da praia e próximo a diversas atrações turísticas, além de ter em seu entorno as melhores opcões em gastronomia, comércio e serviços.',
            tx_adega: 'Um dos mais tradicionais restaurantes de João Pessoa, a Adega fica localizada no LS Hotel. Em seu menu, pratos clássicos e contemporâneos da gastronomia portuguesa e internacional.',
            tx_ippon: 'Localizado no bairro de Tambaú, o Ippon conta com uma ambientação sofisticada, uma ampla área externa e um menu autoral, contemplando a cozinha japonesa e a fusion food.',
            tx_nonno: 'Com localização anexa ao LS Hotel, o Nonno Cucina apresenta uma cozinha italiana moderna e dinâmica, agregando aos seus pratos o valor e o sabor de ingredientes locais.',
            tx_pez: 'O PEZ Fish & Lounge chega ao rooftop do LS Hotel para abrilhantar ainda mais a experiência sensorial e gastronômica do espaço, proporcionando uma viagem à gastronomia peruana contemporânea.',
            tx_deluxe: 'Agradável suíte de 27 metros quadrados, com elegante decoração. Com uma cama de casal ou duas de solteiro, enxoval singular, amenities exclusivas, secador de cabelos, banheiro em mármore e minibar. Obras de arte compõem o ambiente.',
            tx_premium: 'Confortável suíte de 29 metros quadrados, com elegante decoração. Com uma cama de casal, amenities exclusivas, secador de cabelos, banheiro em mármore, minibar  e serviços de mordomia. Obras de arte compõem o ambiente.',
            tx_presidencial: 'Espaçosa suíte de 50 metros quadrados, com elegante decoração. Dispõe de automação de som, ar-condicionado e TV\'s. Com uma cama king size, enxoval elaborado sob medida, amenities personalizadas, secador de cabelos, banheiro em mármore com ofurô individual, chinelos personalizados, spa dos pés, minibar e serviços de mordomia. Obras de arte compõem o ambiente. Decoração romântica exclusiva para o pacote de núpcias - Sob consulta.',
            tx_digite_email: 'DIGITE AQUI SEU E-MAIL',
            logoHeight: 8,
            logoMargin: 1.5,
            sel_rest: 0,
            sel_acomodacao: 1,
            topBarMargin: 50,
            quantCriancas: 0,
            quantAdultos: 2,
            tipoSuite: 0,
            new_email: '',
            baseUrlApi: 'https://advice.domm.com.br:8445/AdviceServer/restapi/search/',
            // baseUrlApi: 'http://localhost:8082/AdviceServer/restapi/search/',
            showPopup: true,
            showPopup2: false,
            showPopup3: false,
            primeiraVezPopup2: true,
            primeiraVezPopup3: true,
            meses: [
                'JANEIRO',
                'FEVEREIRO',
                'MARÇO',
                'ABRIL',
                'MAIO',
                'JUNHO',
                'JULHO',
                'AGOSTO',
                'SETEMBRO',
                'OUTUBRO',
                'NOVEMBRO',
                'DEZEMBRO'
            ],
            semanas: [
                'SEG',
                'TER',
                'QUA',
                'QUI',
                'SEX',
                'SAB',
                'DOM'
            ],
            calendario1: {
                mes: 10,
                dia: 10,
                ano: 2020,
                matrix: []
            },
            calendario2: {
                mes: 10,
                dia: 12,
                ano: 2020,
                matrix: []
            },
            slidesVec1: [],
            slidesVec2: [],
            slidesCur1: 1,
            slidesCur2: 1,
            slidesClickTime: 0,
            slidesAutoTime: 5000,
            slide_home: [
                '/static/imgs/bg_home02.jpg',
                // '/static/imgs/bg_reve2021_2.jpg',
                '/static/imgs/bg_home01.jpg',
                '/static/imgs/bg_home00.jpg',
                '/static/imgs/bg_home03.jpg'
            ],
            slide_deluxe: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ],
            slide_premium: [
                '/static/imgs/im_premium01.jpg',
                '/static/imgs/im_premium02.jpg',
                '/static/imgs/im_premium03.jpg'
            ],
            slide_presidencial: [
                '/static/imgs/im_presidencial01.jpg',
                '/static/imgs/im_presidencial02.jpg',
                '/static/imgs/im_presidencial03.jpg'
            ],
            slide_suites: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ]
        }
    },
    methods: {
        changeSideBar () {
            // console.log('entrei no changeSideBar')
            window.$('#icmenu').toggleClass('open')
            if (!window.$('#sidebar').hasClass('active')) {
                window.$('.overlay').fadeIn()
                window.$('.collapse.in').toggleClass('in')
                window.$('a[aria-expanded=true]').attr('aria-expanded', 'false')
            } else {
                window.$('.overlay').fadeOut()
            }
            window.$('#sidebar').toggleClass('active')
        },
        reservar () {
            var mes1 = '' + (this.calendario1.mes + 1)
            var mes2 = '' + (this.calendario2.mes + 1)
            if (mes1 < 10) {
                mes1 = '0' + (this.calendario1.mes + 1)
            }
            if (mes2 < 10) {
                mes2 = '0' + (this.calendario2.mes + 1)
            }
            var dia1 = this.calendario1.dia
            // console.log('dia1 len: ' + typeof dia1)
            // console.log('dia1 len: ' + dia1.size())
            var dia2 = this.calendario2.dia
            if (dia1 < 10) {
                dia1 = '0' + dia1
            }
            if (dia2 < 10) {
                dia2 = '0' + dia2
            }

            var dataIn = dia1 + mes1 + this.calendario1.ano
            var dataOut = dia2 + mes2 + this.calendario2.ano

            console.log('Datain ', dataIn)
            console.log('Dataout ', dataOut)

            var urlNewBusca = 'https://book.omnibees.com/hotelresults?c=4198&q=7482&NRooms=1&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas
            var urlNewHome = 'https://book.omnibees.com/chain/4198?NRooms=1&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas
            var urlOld = 'https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&Code=&group_code=&loyality_card=&NRooms=1&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas + '&ag=-'
            // https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=02122020&CheckOut=19122020&Code=&group_code=&loyality_card=&NRooms=1&ad=1&ch=0&ag=-
            console.log('urlOld: ' + urlOld)
            console.log('urlNewHome: ' + urlNewHome)
            console.log('urlNewBusca: ' + urlNewBusca)
            this.goToURL(urlNewBusca)
        },
        closePopup () {
            if (this.showPopup) {
                this.showPopup = false
            }
            if (this.showPopup2) {
                this.showPopup2 = false
            }
            if (this.showPopup3) {
                this.showPopup3 = false
            }
        },
        closeKey () {
            console.log('closeKeyboard')
            this.sendNewsletter()
        },
        selectRestaurante (i) {
            this.sel_rest = i
        },
        selectAcomodacao (i) {
            this.sel_acomodacao = i
            switch (i) {
            case 1: this.slide_suites = this.slide_deluxe; break
            case 2: this.slide_suites = this.slide_premium; break
            case 3: this.slide_suites = this.slide_presidencial; break
            }
        },
        selectMenu (i) {
            console.log('selectMenu: ' + i)
            var target
            switch (i) {
            case 0:
                target = document.getElementById('part0')
                break
            case 1:
                target = document.getElementById('part1')
                break
            case 2:
                target = document.getElementById('part2')
                break
            case 3:
                target = document.getElementById('part3')
                break
            case 4:
                target = document.getElementById('part4')
                break
            case 5:
                target = document.getElementById('part5')
                break
            case 6:
                target = document.getElementById('part6')
                break
            case 7:
                this.$router.push({name: 'Blog'})
                break
            default:
                target = document.getElementById('part0')
            }

            if (this.isMobile()) {
                this.changeSideBar()
            }

            window.$('html,body').animate({
                scrollTop: target.offsetTop},
            'slow')
        },
        addEvent (obj, type, fn) {
            if (obj.attachEvent) {
                obj['e' + type + fn] = fn
                obj[type + fn] = function () { obj['e' + type + fn](window.event) }
                obj.attachEvent('on' + type, obj[type + fn])
            } else {
                obj.addEventListener(type, fn, false)
            }
        },
        isMobile () {
            if (window.innerWidth < 861) {
                return true
            } else {
                return false
            }
        },
        goToURL (url) {
            window.open(url, '_blank')
            // location.href = url
        },
        sendNewsletter () {
            var vw = this

            console.log('sendNewsletter ' + this.new_email)
            if (!this.checkEmail()) {
                alert('Endereço de e-mail inválido.')
            } else {
                var url = this.baseUrlApi + 'addnewsletter'

                var data = {
                    'email': this.new_email,
                    idlocal: 100
                }

                console.log('Enviando post com o newsletter: ' + url)
                console.log('data: ', data)
                axios.post(url, qs.stringify(data))
                    .then(function (response) {
                        // vm.loading.form = false;
                        console.log('SUCESS::' + response)
                        vw.showPopup = false
                        vw.showPopup2 = false
                        vw.showPopup3 = false
                    })
                    .catch(function (error) {
                        // vm.loading.form = false;
                        console.log('ERROR::' + error)
                    })

                // LS Server
                data = {
                    'email': this.new_email
                }
                url = 'https://mail.lshotel.com.br/newsletter.php'
                console.log('Enviando post com o newsletter2: ' + url)
                console.log('data2: ', data)
                axios.post(url, qs.stringify(data))
                    .then(function (response) {
                        // vm.loading.form = false;
                        console.log('SUCESS::' + response)
                    })
                    .catch(function (error) {
                        // vm.loading.form = false;
                        console.log('ERROR::' + error)
                    })

                this.sleep(1000).then(() => {
                    alert('Que bom que você está conosco, aproveite a viagem!')

                    // TODO remover essas 2 atribuicoes
                    vw.showPopup = false
                    vw.showPopup2 = false
                    vw.showPopup3 = false
                })
            }
        },
        checkEmail () {
            var email = this.new_email
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        sleep (time) {
            return new Promise((resolve) => setTimeout(resolve, time))
        },
        getMes (calendario, i) {
            // console.log('Entreino getMes: ', calendario, i)

            if (i === 1) {
                calendario.mes++
                if (calendario.mes > 11) {
                    calendario.mes = 0
                    calendario.ano++
                }
            } else if (i === -1) {
                calendario.mes--
                if (calendario.mes < 0) {
                    calendario.mes = 11
                    calendario.ano--
                }
            }

            if (i !== 0) {
                calendario.matrix = this.generateCalendarMatrix(calendario)
                this.selectIntervalo(this.calendario1, this.calendario2)
            }

            return this.meses[calendario.mes]
        }
    },
    created () {
        console.log('Saindo do Created')

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0

            // this.slide_home[1] = '/static/imgs/bg_home01.jpg'
            // this.slide_home[1] = '/static/imgs/bg_reve2021_m4.jpg'
        }
    },
    mounted () {
        console.log('Entrando do Mounted')
        global.jQuery = require('jquery')
        window.$ = global.jQuery

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0
        } else {
            // this.topBarMargin = Math.round(this.elPart0.scrollHeight * 0.05)
            this.topBarMargin = 0
            this.logoHeight = 8
            this.logoMargin = 1.5
        }

        if (this.$route.params.menuIndex != null) {
            this.selectMenu(this.$route.params.menuIndex)
            this.showPopup = false
            this.primeiraVezPopup2 = false
        }

        console.log('Saindo do Mounted')
    }
}
</script>

<style src="../assets/css/side_bar.css" scoped/>
<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/ls.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Popup.vue